import PropTypes from 'prop-types';
import { datePropTypes } from '@Theme/natucare/modules/ArticleHero/components/InfoBar/components/Date/DatePropTypes';
import { dateDetailsPropTypes } from '@Theme/natucare/components/Tooltip/modules/DateDetails/DateDetailsPropTypes';
import { whyTrustUsPropTypes } from '@Theme/natucare/components/Tooltip/modules/WhyTrustUs/WhyTrustUsPropTypes';
import { readingTimePropTypes } from './components/ReadingTime/ReadingTimePropTypes';
export const infoBarPropTypes = {
  /**
   * Activity dates object contain information about updatedAt(string), dateDetails(object) and badges(array of objects)
   */
  activityDates: PropTypes.shape({
    updatedAt: datePropTypes.updatedAt,
    dateDetails: PropTypes.shape(dateDetailsPropTypes)
  }),
  /**
   * Reading time: object with value(number) and unit(string)
   */
  readingTime: PropTypes.exact(readingTimePropTypes).isRequired,
  /**
   * Badges: array of objects containing iconName, description and details object
   */
  badges: PropTypes.arrayOf(PropTypes.shape({
    iconName: PropTypes.string,
    description: PropTypes.string,
    details: PropTypes.shape(whyTrustUsPropTypes)
  }))
};